import { amplitudeKeyInternal, amplitudeKeyOldInternal, amplitudeKeyOldProd, amplitudeKeyProd, appTimestamp, appVersion, arcgisApiKeyProd, autodeskApiUrl, commitId, commitUrl, intercomAppIdProd, jiraTicketId, jiraTicketUrl, localizeKey, muiProKey, procoreApiUrlProduction, pullRequestId, pullRequestUrl, sentryDSNKey } from "@src/runtime-config-base";
export const runtimeConfig = {
  environment: "production",
  appRegion: "eu",
  appEnv: "eu-production",
  urls: {
    apiBaseUrl: "https://core.api.holobuilder.eu",
    analyticsBaseUrl: "",
    sphereViewerUrl: "https://viewer.holobuilder.eu",
    sphereVaultUrl: "https://vault.holobuilder.eu",
    dashboard20Api: "https://sphere.holobuilder.eu/api",
    hbWebEditorUrl: "https://app.holobuilder.eu",
    progressApiUrl: "https://progress.api.holobuilder.eu",
    sphereEntryPageUrl: "https://entry.holobuilder.eu",
    adminPanelUrl: "https://admin.holobuilder.eu",
    cookieManagerUrl: "https://cookies.holobuilder.eu/cookie-manager/manager/latest",
    powerBIBaseUrl: "https://hb-powerbi-func-eu.azurewebsites.net",
    projectApiUrl: "https://v2.project.api.holobuilder.eu",
    hbDashboardUrl: "https://dashboard.holobuilder.eu",
    uploadFrontDoorUrl: "https://files.holobuilder.eu",
    uploadStorageUrl: "https://holobuildereucorestorage.blob.core.windows.net",
    activityApiUrl: "https://activity.api.holobuilder.eu"
  },
  features: {
    muiProKey,
    localizeKey,
    sentryDSNKey,
    auth0: {
      domain: "login.eu.farosphere.com",
      clientId: "VIgbt2dDKTFhsj2as6umqhKylJ01psTg"
    },
    amplitudeKeyInternal,
    amplitudeKeyProd,
    amplitudeKeyOldInternal,
    amplitudeKeyOldProd,
    intercomAppId: intercomAppIdProd,
    arcgisApiKey: arcgisApiKeyProd
  },
  integrations: {
    procoreApiUrl: procoreApiUrlProduction,
    autodeskApiUrl
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support-eu@holobuilder.com",
  isNumberedEnv: false,
  numberedEnv: null
};